// <s-mega-menu> opens the desktop Shop panel on hover (with a short close delay so the
// pointer can travel from the trigger into the panel), on click, and from the keyboard.
// Hovering or focusing a category tab swaps the product pane beside it.
class SMegaMenu extends HTMLElement {
  #closeTimer = null;

  connectedCallback() {
    this.trigger = this.querySelector('[data-mega-trigger]');
    this.panel = this.querySelector('[data-mega-panel]');
    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', this.#onClick);
    this.addEventListener('pointerenter', this.#onEnter);
    this.addEventListener('pointerleave', this.#onLeave);
    this.addEventListener('keydown', this.#onKeydown);
    this.addEventListener('focusout', this.#onFocusOut);
    this.panel.addEventListener('pointerover', this.#onTabIntent);
    this.panel.addEventListener('focusin', this.#onTabIntent);
  }

  disconnectedCallback() {
    clearTimeout(this.#closeTimer);
    this.trigger?.removeEventListener('click', this.#onClick);
    this.removeEventListener('pointerenter', this.#onEnter);
    this.removeEventListener('pointerleave', this.#onLeave);
    this.removeEventListener('keydown', this.#onKeydown);
    this.removeEventListener('focusout', this.#onFocusOut);
    this.panel?.removeEventListener('pointerover', this.#onTabIntent);
    this.panel?.removeEventListener('focusin', this.#onTabIntent);
  }

  #open() {
    clearTimeout(this.#closeTimer);
    this.setAttribute('data-open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  #close() {
    clearTimeout(this.#closeTimer);
    this.removeAttribute('data-open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  #onClick = () => {
    if (this.hasAttribute('data-open')) this.#close();
    else this.#open();
  };

  #onEnter = (event) => {
    if (event.pointerType === 'mouse') this.#open();
  };

  #onLeave = (event) => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(this.#closeTimer);
    this.#closeTimer = setTimeout(() => this.#close(), 220);
  };

  #onKeydown = (event) => {
    if (event.key === 'Escape' && this.hasAttribute('data-open')) {
      this.#close();
      this.trigger.focus();
    }
  };

  #onFocusOut = (event) => {
    if (!this.contains(event.relatedTarget)) this.#close();
  };

  #onTabIntent = (event) => {
    const tab = event.target.closest('[data-mega-tab]');
    if (!tab || tab.hasAttribute('data-active')) return;
    const index = tab.dataset.megaTab;
    this.querySelectorAll('[data-mega-tab]').forEach((el) => el.toggleAttribute('data-active', el === tab));
    this.querySelectorAll('[data-mega-pane]').forEach((pane) => {
      pane.hidden = pane.dataset.megaPane !== index;
    });
  };
}

if (!customElements.get('s-mega-menu')) customElements.define('s-mega-menu', SMegaMenu);
